import { useEffect } from 'react';

import { jwtDecode } from 'jwt-decode';
import { useNavigate, useSearchParams } from 'react-router';

import { useLoginTrip } from '@/features/auth/api/useLoginTrip';
import { setGxToken, setImpostorToken } from '@/features/auth/authToken';
import { storage, StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { redirectTo } from '@/shared/lib/url/navigation';

type DecodedToken = {
  impersonatorEmail?: string;
};

export const useTokenAuth = () => {
  const { mutate: loginTrip } = useLoginTrip();
  const navigate = useNavigate();

  const [urlSearchParams] = useSearchParams();
  const urlToken = urlSearchParams.get('token');
  const gxToken = useStorageValue(StorageKeys.GxToken);
  const lastPathname = useStorageValue(StorageKeys.LastPathname);

  const isReady = Boolean(gxToken) && lastPathname === null;

  useEffect(() => {
    if (gxToken && urlToken) {
      const decoded = jwtDecode<DecodedToken>(urlToken);
      if (decoded.impersonatorEmail) {
        setImpostorToken(urlToken, decoded.impersonatorEmail);
        redirectTo('/');
        return;
      }
    }
    if (gxToken) {
      if (lastPathname && lastPathname !== '/login') {
        storage.remove(StorageKeys.LastPathname);
        navigate(lastPathname);
      }
    } else if (urlToken) {
      loginTrip(urlToken, {
        onSuccess: () => {
          setGxToken(urlToken);
        }
      });
    } else {
      navigate('/login');
    }
  }, [gxToken, urlToken, lastPathname, loginTrip, navigate]);

  return { isReady };
};
